import Vue from 'vue';
import Index from './Index.vue';
import App from './App.vue';
import Preview from './Preview.vue';
import './plugins/element.js';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

Vue.config.productionTip = false;

const routes = [
  { path: '/:id', component: Index },
  { path: '/preview/:id', component: Preview },
];

const router = new VueRouter({
  routes,
});

new Vue({ router, render: h => h(App) }).$mount('#app');
